import { NavigationGuard } from 'vue-router';

import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

export const productsViewGuard: NavigationGuard = (_to, _from, next) => {
  const isFeatureFlagEnabled = FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_PRODUCT_SHELF_INVESTMENT_WITHDRAW
  );

  if (!isFeatureFlagEnabled) {
    return next({ name: 'home' });
  }

  next();
};
